"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUpGraalVMTrunk = void 0;
const c = __importStar(require("./constants"));
const core = __importStar(require("@actions/core"));
const tc = __importStar(require("@actions/tool-cache"));
const child_process_1 = require("child_process");
const io_1 = require("@actions/io");
const utils_1 = require("./utils");
const path_1 = require("path");
const GRAALVM_TRUNK_DL = 'https://github.com/oracle/graal/archive/refs/heads/master.zip';
const GRAALVM_MX_DL = 'https://github.com/graalvm/mx/archive/refs/heads/master.zip';
const DEFAULT_SUITES = '/compiler,/regex,/sdk,/tools,/truffle';
const GRAAL_REPO_DIR = (0, path_1.join)(c.GRAALVM_BASE, 'graal');
const VM_DIR = (0, path_1.join)(GRAAL_REPO_DIR, 'vm');
const MX_DIR = (0, path_1.join)(c.GRAALVM_BASE, 'mx');
const MX_EXEC = c.IS_WINDOWS ? 'mx.cmd' : 'mx';
const SPAWN_OPTIONS = {
    cwd: VM_DIR,
    encoding: 'utf8',
    stdio: 'inherit'
};
const COMPONENTS_TO_SUITE_NAME = new Map([
    ['espresso', '/espresso'],
    ['js', '/graal-js'],
    ['llvm-toolchain', '/sulong'],
    ['native-image', '/substratevm'],
    ['nodejs', '/graal-nodejs'],
    ['python', 'graalpython'],
    ['R', 'fastr'],
    ['ruby', 'truffleruby'],
    ['wasm', '/wasm']
]);
function setUpGraalVMTrunk(javaVersion, components) {
    return __awaiter(this, void 0, void 0, function* () {
        const jdkId = `labsjdk-ce-${javaVersion}`;
        core.startGroup(`Downloading GraalVM sources, mx, and ${jdkId}...`);
        yield tc.extractZip(yield tc.downloadTool(GRAALVM_TRUNK_DL), c.GRAALVM_BASE);
        yield (0, io_1.mv)((0, path_1.join)(c.GRAALVM_BASE, 'graal-master'), GRAAL_REPO_DIR);
        yield tc.extractZip(yield tc.downloadTool(GRAALVM_MX_DL), c.GRAALVM_BASE);
        yield (0, io_1.mv)((0, path_1.join)(c.GRAALVM_BASE, 'mx-master'), MX_DIR);
        core.addPath(MX_DIR);
        core.debug(`"${MX_DIR}" added to $PATH`);
        const labsJDKDir = (0, path_1.join)(c.GRAALVM_BASE, 'labsjdk');
        yield (0, io_1.mkdirP)(labsJDKDir);
        (0, child_process_1.spawnSync)(MX_EXEC, ['--java-home=', 'fetch-jdk', '--jdk-id', jdkId, '--to', labsJDKDir], SPAWN_OPTIONS);
        const labsJDKHome = (0, utils_1.findJavaHomeInSubfolder)(labsJDKDir);
        core.exportVariable('JAVA_HOME', labsJDKHome);
        core.debug(`$JAVA_HOME set to "${labsJDKHome}"`);
        core.endGroup();
        const dynamicImports = toSuiteNames(components).join(',');
        const mxArgs = [
            '--no-download-progress',
            '--disable-installables=true',
            '--force-bash-launchers=true',
            '--disable-libpolyglot',
            '--exclude-components=LibGraal',
            '--dynamicimports',
            dynamicImports
        ];
        if (core.isDebug()) {
            (0, child_process_1.spawnSync)(MX_EXEC, mxArgs.concat('graalvm-show'), SPAWN_OPTIONS);
        }
        const graalvmHome = (0, child_process_1.spawnSync)(MX_EXEC, mxArgs.concat(['graalvm-home']), Object.assign(Object.assign({}, SPAWN_OPTIONS), { stdio: 'pipe' }));
        core.startGroup('Building GraalVM CE from source...');
        (0, child_process_1.spawnSync)(MX_EXEC, mxArgs.concat(['build']), SPAWN_OPTIONS);
        core.endGroup();
        const graalvmHomePath = graalvmHome.stdout.trim();
        if (core.isDebug()) {
            const cmd = c.IS_WINDOWS ? 'dir' : 'ls';
            (0, child_process_1.spawnSync)(cmd, [graalvmHomePath], { stdio: 'inherit' });
        }
        return graalvmHomePath;
    });
}
exports.setUpGraalVMTrunk = setUpGraalVMTrunk;
function toSuiteNames(components) {
    const names = [DEFAULT_SUITES];
    for (const component of components) {
        const suiteName = COMPONENTS_TO_SUITE_NAME.get(component);
        if (suiteName) {
            names.push(suiteName);
        }
        else {
            throw new Error(`Unsupported component: ${component}`);
        }
    }
    return names;
}
